// extracted by css-extract-rspack-plugin
export default {"AppBarRoot":"AppBar-module__AppBarRoot___MdZZp"};